import { render, staticRenderFns } from "./CommonContainer.vue?vue&type=template&id=4dbf03ca&"
import script from "./CommonContainer.vue?vue&type=script&lang=js&"
export * from "./CommonContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports